<template>
    <div>
        <b-row align-h="center">
            <b-col cols="10">
                <div class="contTitleLine">
                    <h3>Mis carreras</h3>
                    <div class="lineTitle"></div>
                </div>
            </b-col>
            <b-col class="mt-2" cols="11">
                <b-form-group id="form-search-simulacro">
                    <img src="@/assets/images/Search.svg"/>
                    <b-form-input
                            id="input-2"
                            v-model="search"
                            required
                            placeholder="Busca carrera"
                            size="lg"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3">
            <b-col cols="10">
                <p @click="AgregarCarrera()" class="plus-simulacro">
                    <img src="@/assets/images/plus.png" alt/>
                    Agregar carrera
                </p>
            </b-col>
        </b-row>
        <b-row v-for="(items, key) in filteredData" :key="key" align-h="center" align-v="center">
            <b-col cols="10" style="border-color:#0F376E" class="filaCarrera">
                <b-row>
                    <b-col align-self="center" cols="9">
                        <p class="titulo-simulacro-admin" style>{{items.nombre}}</p>
                    </b-col>
                    <b-col cols="1" class>
                        <p
                                style="cursor:pointer"
                                @click="modificarCarrera(items)"
                                class="modificar-carrera"
                        >Modificar</p>
                    </b-col>
                    <b-col cols="2">
                        <button class="button-modificar-carrera" @click="removeCarrera(items)">Eliminar</button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="10">
                <div class="contTitleLine">
                    <h3>Intrucciones</h3>
                    <div class="lineTitle"></div>
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-2" align-h="center">
            <b-col cols="3">
                <b-card
                        header="Instrucciones"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p class="info-text">Generales</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        @click="editar('Instrucciónes', 'General', 1)"
                                        class=""
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col cols="3">
                <b-card
                        header="Instrucciones"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p class="info-text">Por Módulo</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        @click="editar('Instrucciónes', 'Módulo', 2)"
                                        class=""
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>

        <b-row align-h="center">
            <b-col cols="10">
                <div class="contTitleLine">
                    <h3>Animaciones</h3>
                    <div class="lineTitle"></div>
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-2" align-h="center">
            <b-col cols="3">
                <b-card
                        header="Animaciones"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p class="info-text">Simulacros</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        class=""
                                        @click="editar('Animaciónes', 'Simulacro',3)"
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col cols="3">
                <b-card
                        header="Animaciones"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p class="info-text">Resultados</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        class=""
                                        @click="editar('Animaciónes', 'Resultados',4)"
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="10">
                <div class="contTitleLine">
                    <h3>Claves por modulos</h3>
                    <div class="lineTitle"></div>
                </div>
            </b-col>
        </b-row>
        <b-row class="mt-2" align-h="center">
            <b-col class="mt-4" v-for="(items, key) in modulos" :key="key" cols="3">
                <b-card
                        :header="'Módulo '+(key+1)"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p class="info-text mt-1">{{items.titulo}}</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        class=""
                                        @click="editarclave(items.id_modulo)"
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-modal content-class="modal-carrera" hide-footer ref="modal-carrera" centered size="lg">
            <b-row align-h="center" class="mt-5 examen-finish">
                <p class="fondo-carrera" style="color:#0F376E">{{titulo_carrera}}</p>
            </b-row>
            <b-row align-h="center" class="mt-n4">
                <b-col lg="8">
                    <b-form-select
                            class="mt-4 input-register carrera-select"
                            id="carrera"
                            placeholder="Colegio"
                            ref="carrera"
                            v-model="id_carrera"
                    >
                        <option :value="null" class="placehold-select" disabled>
                            <p style="font-size:12px!important">Carrera</p>
                        </option>
                        <option
                                v-for="(items, key) in carrerasselect"
                                :value="items.id"
                                :key="key"
                        >{{ items.nombre }}
                        </option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col lg="8">
                    <input
                            required
                            placeholder="Puntaje minimo"
                            class="pl-2 mt-4 account-dame"
                            type="text"
                            v-model="puntaje"
                            id="password"
                    />
                </b-col>
            </b-row>

            <b-row align-h="center" class="mb-4 mt-4">
                <button
                        @click="agregarCarrera()"
                        style="background:#0F376E!important"
                        class="password-aceptar"
                >ACEPTAR
                </button>
            </b-row>
        </b-modal>
        <b-modal content-class="modal-delete-puntajexcarrera" hide-footer ref="modal-delete-puntajexcarrera" centered size="lg">
            <b-row align-h="center" class="mt-5 examen-finish">
                <p class="fondo-carrera" style="color:#0F376E">Eliminar Puntaje por Carrera</p>
            </b-row>
            <b-row align-h="center" class="mt-n4">
                <b-col lg="8">
                    <b-form-select
                            class="mt-4 input-register carrera-select"
                            id="carrera"
                            placeholder="Colegio"
                            ref="carrera"
                            v-model="id_carrera"
                            disabled
                    >
                        <option :value="null" class="placehold-select" disabled>
                            <p style="font-size:12px!important">Carrera</p>
                        </option>
                        <option
                                v-for="(items, key) in carrerasselect"
                                :value="items.id"
                                :key="key"
                        >{{ items.nombre }}
                        </option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mb-1 mt-3 ml-1">
                <b-col lg="4">
                    <button
                            @click="cancel2()"
                            style="color:#0F376E!important"
                            class="modal-button-cancel"
                    >CANCELAR</button>
                </b-col>
                <b-col lg="4">
                    <button
                            @click="deleteCarrera()"
                            style="background-color:#0F376E!important"
                            class="modal-button-accept"
                    >ACEPTAR</button>
                </b-col>
            </b-row>
        </b-modal>

    </div>
</template>
<script>
    export default {
        name: "Information",
        props: {
            url: String
        },
        data: () => ({
            search: "",
            carrerasselect: [],
            simulacros: "",
            carreras: "",
            modulos: "",
            id_carrera: "",
            puntaje: "",
            titulo_carrera: "",
            carrerapuntaje: "",
            idpuntajecarrera: ""
        }),
        created() {
            this.$store.dispatch("setNav", "active");
            this.getCarreras();
            this.$store.dispatch("getSimulacros").then(response => {
                this.simulacros = response.data.simulacro;
            });
            this.$store.dispatch("getCareer").then(response => {
                this.carrerasselect = response.data.carrera;
            });
            this.$store
                .dispatch("getModulosSimulacros", localStorage.getItem("id_simulacro"))
                .then(response => {
                    this.modulos = response.data.modulos;
                })
                .catch(error => {
                    console.log(error.message);
                });
        },
        methods: {
            getCarreras() {
                this.$store
                    .dispatch("getCarreraSimulacro", localStorage.getItem("id_simulacro"))
                    .then(response => {
                        this.carreras = response.data.carreras;
                    });
            },
            goRouter(link) {
                //this.$store.dispatch('setSimulacros', id)
                this.$router.push({name: link});
            },
            editarclave(id) {
                localStorage.setItem("id_modulo", id);
                this.$router.push({
                    name: "editar-claves"
                });
                console.log(id);
            },
            agregarCarrera() {
                let data = {
                    id_carrera: this.id_carrera,
                    puntaje: this.puntaje,
                    id_simulacro: localStorage.getItem("id_simulacro")
                };
                this.$store
                    .dispatch("postCarreraSimulacro", data)
                    .then(response => {
                        this.carrerapuntaje = response.data.carrera;
                        this.getCarreras();
                        this.$refs["modal-carrera"].hide();

                        this.puntaje = "";
                        this.id_carrera = "";
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            editar(tipo, nombre, type) {
                let info = {
                    tipo: tipo,
                    nombre: nombre,
                    type: type
                };
                localStorage.setItem("info", JSON.stringify(info));
                this.$router.push({
                    name: "editar-informacion"
                });
            },
            modificarCarrera(items) {
                this.id_carrera = items.id_carrera;
                this.puntaje = items.puntaje_minimo;
                this.titulo_carrera = "MODIFICAR CARRERA";
                this.$refs["modal-carrera"].show();
            },
            removeCarrera(items) {
                console.log('removeCarrera', items);
                this.id_carrera = items.id_carrera;
                this.idpuntajecarrera = items.id;
                this.$refs["modal-delete-puntajexcarrera"].show();
            },
            cancel2(){
                this.$refs["modal-delete-puntajexcarrera"].hide();
            },
            deleteCarrera() {
                console.log('eliminar puntaje por carrera', this.idpuntajecarrera)
                this.$store
                    .dispatch("deletePuntajesxcarrera", this.idpuntajecarrera)
                    .then((response) => {
                       console.log('deletePuntajesxcarrera', response.data.status);
                       if (response.data.status) {
                           this.$refs["modal-delete-puntajexcarrera"].hide();
                           this.getCarreras();
                       } else {
                           this.$alert("No puede eliminar esta asociado a un modulo", 'Opción', 'warning');
                       }

                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },
            AgregarCarrera() {
                this.titulo_carrera = "NUEVA CARRERA";

                this.$refs["modal-carrera"].show();
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters["isAdmin"];
            },
            filteredData: function () {
                var data = this.carreras;
                var filterKey = this.search && this.search.toLowerCase();
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return (
                                String(row[key])
                                    .toLowerCase()
                                    .indexOf(filterKey) > -1
                            );
                        });
                    });
                }
                return data;
            }
        }
    };
</script>
<style scoped>
</style>